<template>
  <div>
    <div class="text-normal p-3">
      <template v-if="!isCustomer">
        <h4 class="header-tablepage">
          New Ticket
          <span class="badge badge-new badge-pill">New</span>
        </h4>
        <div class="title-tabs mt-3">Ticket Form</div>
      </template>
      <div class="no-gutters bg-white ticket">
        <div :class="isCustomer ? '' : 'pt-3 pb-15'">
          <FormInputList
            ref="form"
            :items="formDetail.fields || []"
            :depth="0"
            :errors="$v.formDetail.fields"
            :currentPage="currentPage"
            :pluginEmail="formDetail.pluginEmail"
            :is-customer="isCustomer"
          />

          <div class="pagination-wrapper" v-if="hasPage">
            <div>{{ currentPage }} / {{ totalPage }}</div>
            <div class="pagination-action">
              <b-button
                class="btn main-color btn-save w-100px"
                :disabled="currentPage == 1"
                @click="prevPage"
              >
                Previous</b-button
              >

              <b-button
                class="btn main-color btn-save w-100px"
                :disabled="currentPage == totalPage"
                @click="nextPage"
              >
                Next</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterAction backAction @routePath="onCancel" @submit="sendForm(0)" />
  </div>
</template>

<script>
/* eslint-disable */
import FormInputList from "@/components/FormInputList";
import FooterAction from "@/components/FooterAction";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  components: {
    FormInputList,
    FooterAction,
  },
  props: {
    isCustomer: { required: false, type: Boolean, default: false },
  },
  data() {
    return {
      isLoading: true,
      isSubmit: false,
      currentPage: 1,
      formDetail: {
        id: 1,
        name: "",
        url_key: "",
        valid_form: null,
        valid_to: null,
        description: "",
        active: 1,
        is_default: 0,
        fields: [],
      },
    };
  },
  computed: {
    formStatus() {
      return this.formDetail.fields.find((el) => el.ticket_field_id == 5).value;
    },
    hasPage() {
      return this.formDetail.fields.some((el) => el.field_type_id == 14);
    },
    totalPage() {
      return this.formDetail.fields[this.formDetail.fields.length - 1].page;
    },
  },
  validations() {
    return {
      formDetail: {
        fields: {
          $each: {
            value: {
              required: requiredIf(function (item, vm) {
                const isSubmit = Boolean(item.is_require_submit);

                return isSubmit;
              }),
            },
            field_dependent: {
              $each: {
                value: {
                  required: requiredIf(function (item) {
                    const isSubmit =
                      Boolean(item.is_require_submit) && item.isActive;

                    return isSubmit;
                  }),
                },
                field_dependent: {
                  $each: {
                    value: {
                      required: requiredIf(function (item) {
                        const isSubmit =
                          Boolean(item.is_require_submit) && item.isActive;

                        return isSubmit;
                      }),
                    },
                  },
                },
              },
            },
          },
        },
      },
    };
  },
  async created() {
    this.getFormDetail();
  },
  methods: {
    nextPage() {
      this.currentPage += 1;
      this.$forceUpdate();
    },
    prevPage() {
      this.currentPage -= 1;
      this.$forceUpdate();
    },
    getAdminList: async function () {
      const payload = {
        search: "",
        user_guid: this.$route.query.user_guid,
        page: 1,
        take: 5,
        pageSize: 5,
      };
      const { data } = await this.axios.post(`/ticket/filter/admin`, payload);
      if (data.detail.data.length >= 1) {
        this.formDetail.fields.find(
          (el) => el.ticket_field_id == 7,
        ).displayValue = [
          data.detail.data[0].name,
          data.detail.data[0].telephone,
        ]
          .filter((el) => el)
          .join(", ");
        this.formDetail.fields.find((el) => el.ticket_field_id == 7).value =
          data.detail.data[0].user_guid;
        // this.isAssignTome = isAssignTome;
        this.$forceUpdate();
      }
    },
    getCustomer: async function () {
      // this.isBusy = true;

      const payload = {
        page: 1,
        take: 5,
        pageSize: 5,
        search: this.$route.query.telephone,
      };
      const { data } = await this.axios.post(
        `/ticket/filter/customer`,
        payload,
      );
      if (data.detail.data.length >= 1) {
        this.$refs.form.isUserHasEmail = data.detail.data[0].email
          ? true
          : false;
        this.formDetail.fields.find(
          (el) => el.ticket_field_id == 1,
        ).displayValue = [
          data.detail.data[0].name,
          data.detail.data[0].telephone,
        ]
          .filter((el) => el)
          .join(", ");
        this.formDetail.fields.find((el) => el.ticket_field_id == 1).value =
          data.detail.data[0].user_guid;
        this.$forceUpdate();
      }
      // this.isBusy = false;
    },
    async getFormDetail() {
      const { data } = await this.axios(`/ticket/form/1`);
      if (this.$route.query.user_guid) this.getAdminList();
      if (this.$route.query.telephone) this.getCustomer();
      if (data.result === 1) {
        data.detail.fields.forEach((element) => {
          element.field_dependent = this.mapFieldFromDepth(
            element.field_dependent,
            element.id,
          );
        });
        if (this.isCustomer) {
          const field = data.detail.fields.filter((el) =>
            [3, 4, 6, 1, 2, 5].includes(el.ticket_field_id),
          );

          console.log(field);
          data.detail.fields = field;
        }

        this.formDetail = data.detail;
        this.formDetail.fields = this.mappingValue(this.formDetail.fields);
      }
    },
    mapFieldFromDepth(fields, parentId = null) {
      if (!fields?.length) return [];
      return fields
        .filter((el) => el.parent_id === parentId)
        .map((el) => {
          return {
            ...el,
            field_dependent: this.mapFieldFromDepth(
              fields,
              el.ticket_form_field_id,
            ),
          };
        });
    },
    mappingValue(items, page = 1) {
      if (!items.length) return;
      return items.map((el, index) => {
        if (items[index - 1] && items[index - 1].field_type_id == 14) page += 1;

        if (el.field_dependent?.length)
          el.field_dependent = this.mappingValue(el.field_dependent, page);

        let value = null;

        if ([2, 3, 4].includes(el.field_type_id)) {
          const defaultValue = el.field_choice
            .filter((val) => Boolean(val.isDefault))
            .map((val) => {
              return el.field_type_id == 3 ? { ...val } : val.id;
            });

          value = [2, 3].includes(el.field_type_id)
            ? defaultValue || []
            : defaultValue[0] || null;
        } else if (el.name === "RelatedTicket") {
          value = [];
        }

        let source = null;
        if (el.ticket_field_id == 2 && this.$route.query.channel) {
          source = el.field_choice.find(
            (el) =>
              el.name.toLowerCase() == this.$route.query.channel.toLowerCase(),
          );
          source = source ? source.id : null;
        }
        if (el.ticket_field_id == 5 && this.$route.query.status) {
          let status = el.field_choice.find(
            (el) =>
              el.name.toLowerCase() == this.$route.query.status.toLowerCase(),
          );
          value = status ? status.id : null;
        }

        return {
          ...el,
          value: el.ticket_field_id == 2 ? source : value,
          displayValue: "",
          page,
        };
      });
    },

    flatFields(data) {
      return data
        .reduce((acc, x) => {
          acc = acc.concat(x);
          if (x.field_dependent) {
            acc = acc.concat(this.flatFields(x.field_dependent));
            x.field_dependent = [];
          }
          return acc;
        }, [])
        .map((el) => {
          let value = el.value;
          let rawValue = el.value;
          if (el.field_type_id == 2)
            value = el.value.map((item) => item).join(",");
          else if (el.field_type_id == 3)
            value = el.value.map((item) => item.id).join(",");
          else if (el.ticket_field_id == 6) value = el.value ? el.value.id : "";
          else if (el.name == "RelatedTicket") {
            value = el.value
              .map((item) => item.ticket_relate_type_id)
              .join(",");
          }

          return {
            id: 0,
            ticket_form_field_id: el.ticket_form_field_id || el.id,
            ticket_field_id: el.ticket_field_id,
            value: String(value),
            is_default_field: el.is_default_field,
            field_dependent: el.field_dependent?.length
              ? this.flatFields(el.field_dependent)
              : [],
            rawValue: String(rawValue),
            name: el.name,
          };
        });
    },

    async sendForm() {
      this.$v.formDetail.$touch();
      console.log(this.$v.formDetail);
      if (this.$v.formDetail.$error) {
        return;
      }

      const field_answer = this.flatFields(this.formDetail.fields);
      let file = this.$refs.form.fileAttach.map((el) => {
        return { fileName: el.name, path: el.path };
      });
      const ticket = field_answer.find(
        (answer) => answer.name == "RelatedTicket",
      );
      const relatedTicketValue = ticket
        ? ticket.rawValue.map((answer) => {
            return {
              id: answer.id,
              ticket_relate_type_id: answer.ticket_relate_type_id,
              ticket_relate_ref_id: answer.ticket_relate_ref_id,
            };
          })
        : [];
      const payload = {
        id: 0,
        ticket_form_id: 1,
        field_answer,
        is_send_mail_customer: this.$refs.form.is_send_mail_customer || false,
        attach_file: file.length == 0 ? null : file,
        ticket_relate_list: relatedTicketValue,
      };
      const { data } = await this.axios.post(`/ticket`, payload);

      if (data.result == 1) {
        this.isLoading = false;

        this.successAlert().then(() => {
          window.parent.postMessage(
            "onCreateTicketSuccess",
            this.$parentOrigin,
          );
        });
      } else {
        this.isLoading = false;
        this.errorAlert(data.message);
      }
    },

    async getBranchList(field, id) {
      await this.$store.dispatch("getBranch", parseInt(id));
      field.branch_list = this.$store.state.coupon.branchList.detail;
      this.branchList = this.$store.state.coupon.branchList.detail;
    },
    onCancel() {
      // console.log("object", this.$parentOrigin);
      window.parent.postMessage("onCancelModal", this.$parentOrigin);
      this.$router.push("/customer/ticket");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .text-float-normal .input-custom {
  label {
    color: #5b5b5b;
    font-size: 16px;
    font-weight: 100;
  }
}

#footer {
  position: fixed;
  bottom: 0;
  left: 256px;
  right: 0;
  height: 10%;
  padding: 15px;
  background: #fff;
}

.badge-new {
  background-color: rgb(39, 189, 167);
  color: white;
  padding: 0.4em 0.6em;
  font-size: 12px;
}

.header-tablepage {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pb-15 {
  padding-bottom: 60px;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .pagination-action {
    display: flex;
    gap: 8px;
    align-items: center;
  }
}

.w-100px {
  width: 101px !important;
  min-width: 0 !important;
}
.ticket {
  height: 90vh;
  overflow: auto;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
